import Instagram from "./instagram-body";

export default Instagram;